import { UseFormReturn } from 'react-hook-form';
import { EventPanelFormType } from '@mark43/cad-api';
import { LoadingIndicator } from '../common/components/loading-indicator';
import { FrUnassignCurrentUserUnitContainer } from './components/fr-unassign-current-user-unit-container';
import { useUpdateDispositionOrClearEventContent } from '../fr-event-common-components/fr-disposition/hooks/use-update-disposition-or-clear-event-content';
import { FrClearOrUnassignPageContent } from '../fr-clear-event-page/components/fr-clear-or-unassign-page-content';
import { useIntegratedForm } from '../forms/use-integrated-form';

export function FrUnassignCurrentUserUnitPage() {
    const {
        eventId,
        unitId,
        isPrimaryUnit,
        dispositionOptions,
        agencyId,
        agencyTypeGlobalAttrId,
        cautions,
        areCautionsLoading,
        eventLocation,
        eventForm,
    } = useUpdateDispositionOrClearEventContent();
    const { query: eventQuery } = useIntegratedForm();

    if (eventQuery.isFetching) {
        return <LoadingIndicator />;
    }

    return (
        <FrUnassignCurrentUserUnitContainer>
            <FrClearOrUnassignPageContent
                isUnassignCurrentUserUnitPage
                saveMutationErrorMsg="unassign myself"
                eventId={eventId}
                unitId={unitId}
                isPrimaryUnit={isPrimaryUnit}
                dispositionOptions={dispositionOptions}
                agencyId={agencyId}
                agencyTypeGlobalAttrId={agencyTypeGlobalAttrId}
                cautions={cautions}
                areCautionsLoading={areCautionsLoading}
                eventLocation={eventLocation}
                eventForm={(eventForm as unknown) as UseFormReturn<EventPanelFormType>}
            />
        </FrUnassignCurrentUserUnitContainer>
    );
}
